import RadioGroup from "../../../DesignSystem/Inputs/RadioGroup";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../../../constants/appRoutes";
import ButtonTextLink from "../../../DesignSystem/Buttons/ButtonTextLink";
import FlaggedChargesTable from "../components/FlaggedChargesTable";
import { getFlaggedCharges } from "../components/FlaggedChargesTable";
import { useState } from "react";
import MonthlyChargesInsights from "../components/MonthlyChargesInsights";
import { useChargeReviews } from "../hooks/useChargeReviews";

const ChargesSummary = ({
  selectedMonth,
  monthOptions,
  onMonthChange,
  chargeRecords,
  onTakeAction,
  chargesLoading,
  chargeErrors = [],
}) => {
  const navigate = useNavigate();
  const [showLogs, setShowLogs] = useState(false);
  const { activeRecords, logs, takeAction, reviewError, reviewsLoading } = useChargeReviews(
    chargeRecords || [], selectedMonth, !chargesLoading && !chargeErrors.filter(Boolean).length,
  );
  const hasFlags =
    getFlaggedCharges(activeRecords, selectedMonth).length > 0;
  return (
    <section
      aria-label="Charges summary"
      data-month={selectedMonth}
      className="fit-column gap-l"
    >
      <header className="row space-between gap-l">
        <h3 className="FP_H3">Charges Summary Dashboard</h3>
      </header>
      <div role="group" aria-label="Charges Summary Dashboard month">
        <RadioGroup
          name="charges-summary-month"
          options={monthOptions}
          value={selectedMonth}
          onChange={(event) => onMonthChange(event.target.value)}
          inline
        />
      </div>
      <section className="fit-column gap-s align-left width-100">
        <div className="space-between-row gap-l">
          <h4 className="FP_Subtitle_Semibold text-black">Review Charges</h4>
          <div className="row-wrap gap-m align-center">
            <ButtonTextLink
              label="Guidelines"
              onClick={() =>
                navigate(APP_ROUTES.Guidelines, {
                  state: {
                    returnPath: `${APP_ROUTES.MONTHLY_PAYMENTS}/charges-summary`,
                  },
                })
              }
            />
            <ButtonTextLink
              label={showLogs ? "Hide Logs" : "View Logs"}
              disabled={!logs.length}
              onClick={() => setShowLogs((visible) => !visible)}
            />
          </div>
        </div>
        {!chargesLoading && hasFlags && (
          <div className="FP_Content">
            Review the following monthly charges that may have a variance in the
            amount charged than the expected amount.
          </div>
        )}
      </section>
      {reviewError && <p role="alert">{reviewError}</p>}
      {chargesLoading || reviewsLoading ? (
        <p className="FP_Content" role="status">
          Loading…
        </p>
      ) : (
        <FlaggedChargesTable
          records={activeRecords}
          selectedMonth={selectedMonth}
          onTakeAction={takeAction}
        />
      )}
      {showLogs && logs.length > 0 && (
        <section
          className="fit-column gap-s width-100"
          aria-label="Logs"
        >
          <div className="space-between-row">
            <h4 className="FP_Subtitle_Semibold text-black">Logs</h4>
          </div>
          <p className="FP_Content">
            Monthly charges with recorded review actions.
          </p>
          <FlaggedChargesTable
            records={logs}
            selectedMonth={selectedMonth}
            includeAll
            showVariance={false}
            onTakeAction={takeAction}
          />
        </section>
      )}
      <MonthlyChargesInsights />
    </section>
  );
};
export default ChargesSummary;
